import { Routes } from '@angular/router';
import { protectedGuards } from '../../core/auth/auth.guard';

export const profileShellRoutes: Routes = [
  {
    path: 'profile',
    loadComponent: () => import('./pages/profile/profile').then((module) => module.Profile),
    data: { titleKey: 'routes.profile' },
  },
];

export const profileRoutes: Routes = [
  {
    path: 'transactions',
    canActivate: protectedGuards,
    loadComponent: () =>
      import('./pages/transaction-history/transaction-history').then(
        (module) => module.TransactionHistory,
      ),
    data: { titleKey: 'routes.transactions' },
  },
  {
    path: 'settings',
    canActivate: protectedGuards,
    loadComponent: () => import('./pages/settings/settings').then((module) => module.Settings),
    data: { titleKey: 'routes.settings' },
  },
];
